<template>
  <div class="domain-ip-settings" v-if="Object.keys(user).length > 0">
    <div class="form-group row">
      <div class="col-12">
        <h5 class="section-title">ログイン可能なメールドメイン、およびIPアドレスの設定状況</h5>
        <p class="section-description">
          企業管理画面への不正ログイン防止のため、企業ユーザーのアカウント発行ができるメールドメインは事前に設定した内容に限定しています。<br />
          また、メールドメインごとにログイン可能なIPアドレスも設定を推奨しています。<br />
          ※設定の変更はBloomキャリア登録 運営事務局にて行います
        </p>

        <div class="content-box">
          <p v-if="!ipDomainCheck" class="no-settings-text">
            現在、ログインにおけるメールドメイン/IPアドレスの設定はありません。
          </p>
          <div v-else class="access-control-table">
            <div class="access-control-row access-control-header">
              <div class="domain-col">ドメイン</div>
              <div class="ip-col">IPアドレス</div>
            </div>
            <div
              class="access-control-row"
              v-for="(entry, index) in accessControl"
              :key="index"
            >
              <div class="domain-col">{{ entry.domain }}</div>
              <div class="ip-col">
                <div class="ip-address-box">{{ entry.ip_address }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'DomainIpSettings',
  computed: {
    ...mapGetters({
      user: 'getCurrentUser',
    }),
    ipDomainCheck() {
      return this.user && this.user.ipDomainCheck === 1;
    },
    accessControl() {
      return (this.user && this.user.accessControl) || [];
    },
  },
};
</script>

<style scoped>
.domain-ip-settings {
  margin-top: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.domain-ip-settings .form-group {
  margin-bottom: 0;
  width: 100%;
  padding: 0 5px;
}

.section-title {
  font-family: 'Inter', sans-serif;
  font-size: 17px;
  line-height: 100%;
  letter-spacing: 0;
  font-weight: 700;
  color: #696868ff;
  margin-bottom: 8px;
}

.section-description {
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 13px;
  line-height: 1.4;
  letter-spacing: 0;
  color: #595959;
  margin-bottom: 12px;
}

.content-box {
  border: 1px solid #e4e4e4ff;
  border-radius: 8px;
  padding: 25px 30px;
  background-color: #ffffffff;
  width: 100%;
}

.no-settings-text {
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0;
  color: #787878;
  margin: 0;
}

.access-control-table {
  width: 100%;
}

.access-control-row {
  display: flex;
  align-items: center;
  padding: 10px 0;
}

.access-control-header {
  padding-top: 0;
  padding-bottom: 15px;
}

.access-control-header .domain-col,
.access-control-header .ip-col {
  color: #696868ff;
  font-weight: 500;
}

.domain-col {
  width: 160px;
  flex-shrink: 0;
  font-size: 15px;
  color: #333;
  padding-right: 12px;
}

.ip-col {
  flex: 1;
  min-width: 0;
  font-size: 15px;
  color: #333;
}

.ip-address-box {
  border: 1px solid #e4e4e4ff;
  border-radius: 4px;
  padding: 8px 12px;
  width: 100%;
  box-sizing: border-box;
  overflow-wrap: break-word;
}
</style>
